import React from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow } from '@mui/material';

import OnEditIcon from '../../../../icons/OnEditIcon';
import { reverseFormatDate } from '../../../../utils/dateFunctions';

import classes from '../../../../commonStyles/tables.module.css';

const AssetRequestTableRow = ({ row, onEdit, isDisabled }) => {
    return (
        <>
            <TableRow hover className={`${classes.basicRowStripes}`}>
                <TableCell>{row.code}</TableCell>
                <TableCell>{row.asset}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{reverseFormatDate(row.statusChangeDate) || '-'}</TableCell>
                <TableCell>{row.quantity}</TableCell>
                <TableCell>{reverseFormatDate(row.dateIssued) || '-'}</TableCell>
                <TableCell>{row.user || '-'}</TableCell>
                <TableCell align="right">
                    <OnEditIcon
                        onEdit={() => onEdit(row)}
                        active={!isDisabled}
                    />
                </TableCell>
            </TableRow>
        </>
    );
};

export default AssetRequestTableRow;

AssetRequestTableRow.propTypes = {
    row: PropTypes.object,
    onEdit: PropTypes.func,
    isDisabled: PropTypes.bool
};
